export default __webpack_public_path__ + "assets/images/4.34b851.avif";